export function filterValid<T>(selected: T[], options: { key: T }[]): T[] {
  const valid = options.map(o => o.key);
  return selected.filter(item => valid.includes(item));
}

export function validateChatTitle(title: string): string | null {
  const trimmed = title.trim();
  if (!trimmed) return 'Title cannot be empty';
  if (trimmed.length > 255) return 'Title cannot exceed 255 characters';
  return null;
}
